import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { ConsentDataObject } from 'models/service';

type RequestData = {
  consent: {
    consent_ids: string[];
  };
};

export const acceptConsents = async (data: RequestData) =>
  apiClient.post<ConsentDataObject[], ApiClientResponse<ConsentDataObject[]>>(routes.consents.accept, data);
